
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/general-surgery",
      function () {
        return require("private-next-pages/general-surgery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/general-surgery"])
      });
    }
  